import React, { Component } from 'react';
import logo from '../../logo.svg';
import './header.css';

class header extends Component {

    logOut = () => { 
        this.props.isLogin(false); 
    }

    render() {
        return (
            <div className="header">
                <div className="header-c">
                    <img src={logo} className="App-logo" alt="logo" />
                    <div className="header-c_nav">
                        <nav> 
                            <ul >
                                { 
                                    !this.props.isLog? 
                                    <li><a href="#"> Log In </a></li>                                    
                                    :<li><a href="#" onClick={this.logOut} >Log Out</a></li>                                    
                                }                                
                            </ul>   
                        </nav> 
                    </div>
                </div> 
            </div>
        )
    }
}

export default header;
